"use client";

import { Api } from "@/Apis";
import { useApp, useT } from "@/Hooks";
import { FC, ReactNode, useState } from "react";

type FooterNewsletterFormProps = {
  buttonClassName: string;
  formClassName?: string;
  wrapClassName?: string;
  inputClassName?: string;
  buttonContent?: ReactNode;
  placeholder?: string;
};

const FooterNewsletterForm: FC<FooterNewsletterFormProps> = ({
  buttonClassName,
  formClassName,
  wrapClassName,
  inputClassName = "form-control",
  buttonContent,
  placeholder,
}) => {
  const t = useT();
  const { message } = useApp();
  const [newsletterEmail, setNewsletterEmail] = useState("");
  const [newsletterLoading, setNewsletterLoading] = useState(false);

  const submitNewsletter = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (newsletterLoading || !newsletterEmail.trim()) return;

    setNewsletterLoading(true);
    try {
      const r = await Api.LandingNewsletter.submit({
        Email: newsletterEmail.trim(),
      });
      if (r.Success) {
        message.success(
          t(
            "landing.contact.message.sentSuccessfully",
            undefined,
            "Your message was sent successfully.",
          ),
        );
        setNewsletterEmail("");
      } else {
        message.errors(r.Errors);
      }
    } catch {
      message.error(
        t(
          "landing.crmForm.submitInfoFailed",
          undefined,
          "Failed to submit information.",
        ),
      );
    }
    setNewsletterLoading(false);
  };

  const input = (
    <input
      type="email"
      className={inputClassName}
      placeholder={
        placeholder ??
        t("landing.footer.emailAddress", undefined, "Email address")
      }
      value={newsletterEmail}
      onChange={(e) => setNewsletterEmail(e.target.value)}
      required
      disabled={newsletterLoading}
    />
  );

  const button = (
    <button
      type="submit"
      className={buttonClassName}
      disabled={newsletterLoading}
    >
      {buttonContent ?? t("landing.footer.subscribe", undefined, "Subscribe")}
    </button>
  );

  const form = (
    <form className={formClassName} onSubmit={submitNewsletter}>
      {input}
      {button}
    </form>
  );

  return wrapClassName ? <div className={wrapClassName}>{form}</div> : form;
};

export default FooterNewsletterForm;
